import { c as _c } from "react/compiler-runtime";
import { create } from 'zustand';
import { z } from 'zod';
export const MAX_PROMPT_LENGTH = 600;
export const generateDesignSchema = z.object({
  prompt: z.string().min(1, {
    message: 'Prompt is required.'
  }),
  imageUrl: z.string().url({
    message: 'Valid image URL is required.'
  }).nullable().refine(val => val !== null, {
    message: 'You must upload an image.'
  })
});
const INITIAL_STATE = {
  prompt: '',
  imageUrl: null,
  maskUrl: null,
  country: '',
  keyFeatures: [],
  gardenStyle: 'same-as-original',
  budgetRange: 'budget-medium',
  season: 'Spring',
  imageQuality: 'medium'
};
export const useGenerateFormStore = create(() => INITIAL_STATE);
export const useGeneratePrompt = () => {
  const $ = _c(2);
  const prompt = useGenerateFormStore(_temp);
  const setPrompt = _temp2;
  let t0;
  if ($[0] !== prompt) {
    t0 = {
      prompt,
      setPrompt
    };
    $[0] = prompt;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const useGenerateImageFile = () => {
  const $ = _c(2);
  const imageUrl = useGenerateFormStore(_temp3);
  const setImageUrl = _temp4;
  let t0;
  if ($[0] !== imageUrl) {
    t0 = {
      imageUrl,
      setImageUrl
    };
    $[0] = imageUrl;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const useGenerateMaskFile = () => {
  const $ = _c(2);
  const maskUrl = useGenerateFormStore(_temp5);
  const setMaskUrl = _temp6;
  let t0;
  if ($[0] !== maskUrl) {
    t0 = {
      maskUrl,
      setMaskUrl
    };
    $[0] = maskUrl;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const useGenerateCountry = () => {
  const $ = _c(2);
  const country = useGenerateFormStore(_temp7);
  const setCountry = _temp8;
  let t0;
  if ($[0] !== country) {
    t0 = {
      country,
      setCountry
    };
    $[0] = country;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const useGenerateKeyFeatures = () => {
  const $ = _c(2);
  const keyFeatures = useGenerateFormStore(_temp9);
  const setKeyFeatures = _temp10;
  let t0;
  if ($[0] !== keyFeatures) {
    t0 = {
      keyFeatures,
      setKeyFeatures
    };
    $[0] = keyFeatures;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const useGenerateGardenStyle = () => {
  const $ = _c(2);
  const gardenStyle = useGenerateFormStore(_temp11);
  const setGardenStyle = _temp12;
  let t0;
  if ($[0] !== gardenStyle) {
    t0 = {
      gardenStyle,
      setGardenStyle
    };
    $[0] = gardenStyle;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const useGenerateBudgetRange = () => {
  const $ = _c(2);
  const budgetRange = useGenerateFormStore(_temp13);
  const setBudgetRange = _temp14;
  let t0;
  if ($[0] !== budgetRange) {
    t0 = {
      budgetRange,
      setBudgetRange
    };
    $[0] = budgetRange;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const useGenerateSeason = () => {
  const $ = _c(2);
  const season = useGenerateFormStore(_temp15);
  const setSeason = _temp16;
  let t0;
  if ($[0] !== season) {
    t0 = {
      season,
      setSeason
    };
    $[0] = season;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const useGenerateImageQuality = () => {
  const $ = _c(2);
  const imageQuality = useGenerateFormStore(_temp17);
  const setImageQuality = _temp18;
  let t0;
  if ($[0] !== imageQuality) {
    t0 = {
      imageQuality,
      setImageQuality
    };
    $[0] = imageQuality;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const useResetForm = () => {
  const resetForm = () => useGenerateFormStore.setState(INITIAL_STATE);
  return resetForm;
};
function _temp(state) {
  return state.prompt;
}
function _temp2(prompt_0) {
  return useGenerateFormStore.setState({
    prompt: prompt_0.substring(0, MAX_PROMPT_LENGTH)
  });
}
function _temp3(state) {
  return state.imageUrl;
}
function _temp4(url) {
  return useGenerateFormStore.setState({
    imageUrl: url
  });
}
function _temp5(state) {
  return state.maskUrl;
}
function _temp6(url) {
  return useGenerateFormStore.setState({
    maskUrl: url
  });
}
function _temp7(state) {
  return state.country;
}
function _temp8(country_0) {
  return useGenerateFormStore.setState({
    country: country_0
  });
}
function _temp9(state) {
  return state.keyFeatures;
}
function _temp10(keyFeatures_0) {
  return useGenerateFormStore.setState({
    keyFeatures: keyFeatures_0
  });
}
function _temp11(state) {
  return state.gardenStyle;
}
function _temp12(gardenStyle_0) {
  return useGenerateFormStore.setState({
    gardenStyle: gardenStyle_0
  });
}
function _temp13(state) {
  return state.budgetRange;
}
function _temp14(budgetRange_0) {
  return useGenerateFormStore.setState({
    budgetRange: budgetRange_0
  });
}
function _temp15(state) {
  return state.season;
}
function _temp16(season_0) {
  return useGenerateFormStore.setState({
    season: season_0
  });
}
function _temp17(state) {
  return state.imageQuality;
}
function _temp18(imageQuality_0) {
  return useGenerateFormStore.setState({
    imageQuality: imageQuality_0
  });
}